// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1am0X","largestCol":"styles_largestCol__2BvG6","smallestCol":"styles_smallestCol__2F8Ul"};